(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    


$(function() {
    $('.shop_the_look_wrapper .shop-the-look__item-carousel').slick({
		slidesToShow: 1.5, 
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        infinite:false,
        dots: true,
        dots: false,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function() {
        $('.shop_the_look_wrapper .shop-the-look__item-carousel').slick('resize');
    });
});
  


  } catch(e) { console.error(e); }
})();
})();
